import { getAnalytics } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';
import { browserLocalPersistence, getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
// TODO: Replace the following with your app's Firebase project configuration
const firebaseConfig = {
  apiKey: 'AIzaSyCr0wG_BzoNbrU0dd6ROMLAONVXxIBi0bY',
  authDomain: 'tp-games-de990.firebaseapp.com',
  projectId: 'tp-games-de990',
  storageBucket: 'tp-games-de990.appspot.com',
  messagingSenderId: '292014191253',
  appId: '1:292014191253:web:92f600691500a9c04a219c',
  measurementId: 'G-GXVHFZPF7X',
};
export const firebaseApp = initializeApp(firebaseConfig);
export const analytics = getAnalytics(firebaseApp);
// DEBUG: Connect app to local Firebase emulators
export const firebaseDb = getFirestore(firebaseApp);
// connectFirestoreEmulator(firebaseDb, 'localhost', 8080);
export const firebaseAuth = getAuth(firebaseApp);
// connectAuthEmulator(firebaseAuth, 'http://localhost:9099');
export const firebaseFunctions = getFunctions(firebaseApp);
// connectFunctionsEmulator(firebaseFunctions, 'localhost', 5001);

export const firebasePersistencePromise = firebaseAuth.setPersistence(
  browserLocalPersistence,
);
